import type { FaireProductEntity } from "../../entity_types/product";

export const p_xrscdcxcpu: FaireProductEntity = {
  token: "p_xrscdcxcpu",
  type: "product",
  name: "IMPLANT GRADE SOLID TITANIUM TRIPLE BAGUETTE LINE CZ PUSH IN",
  brandToken: "b_punhnqvhh6",
  brandName: "CRAVE",
  imageUrl: "https://cdn.faire.com/fastly/c979376f72bb7e457f8f6b445404b08dc19d44ffe3fe38e414055be14520128a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/012d2862955d0c921b6fb527b0ce2bd403f5f5f9f07c06c18fee33c16b4a9924.jpeg",
    "https://cdn.faire.com/fastly/4b1e30aa28a2ea34d6d94b6c59f3a3da79971a230ed6955d31dd3650b83ed6e0.jpeg",
    "https://cdn.faire.com/fastly/a212a0b5560a25d22d23464c151224f5994220713db64948a98ecad25ba00cfd.jpeg",
    "https://cdn.faire.com/fastly/7e25b3974fcc6862d0c0ef23ecc153e9240a701e926762eaa319dd8c0246db4b.jpeg",
    "https://cdn.faire.com/fastly/451667860669bc7e558a34158d0822d4441a1481a8fa8ff3c4978b1e8f2cfac5.jpeg"
  ],
  priceDollars: 6.26,
  description: "IMPLANT GRADE SOLID TITANIUM TRIPLE BAGUETTE LINE CZ PUSH IN TOP LABRET\nMaterial: TITANIUM\nThickness: 18GA (1.0MM)\t\nLength:  1/4\" (6MM), 5/16\" (8MM)\nBALL SIZE: 3.6MM X 7.6MM\n\nCrafted from ASTM F136 implant-grade titanium, rigorously tested for professional body piercing, ensuring maximum safety and user-friendly application.",
  tags: [],
  msrpDollars: 15.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:01.878Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
